/**
 * Full-page navigation to another origin (Loop's hosted page). Kept in its
 * own module so tests can mock it instead of fighting jsdom's `location`.
 */
export const navigateExternal = (url: string): void => {
  window.location.assign(url);
};
